
export default function ComparisonTableSection() {
  const comparisonData = [
    {
      feature: 'ディスプレイサイズ',
      'fjd-at2': '10.1インチ',
      'fjd-at2-max': '12.1インチ',
      'fjd-al02': '10.1インチ',
      'fjd-ats': '10.1インチ',
      'esteer-20-max': '12インチ',
      'esteer-20': '10インチ'
    },
    {
      feature: '測位精度',
      'fjd-at2-max': 'RTK ±2.5cm',
      'fjd-at2': 'RTK ±2.5cm',
      'fjd-al02': 'RTK ±2.5cm',
      'fjd-ats': 'RTK ±2.5cm',
      'esteer-20-max': 'RTK ±2.5cm（※1）',
      'esteer-20': 'RTK ±2.5cm'
    },
    {
      feature: '作業速度',
      'fjd-at2-max': '0.5〜26km/h（オプションで0.1km/h）',
      'fjd-at2': '0.5〜26km/h（オプションで0.1km/h）',
      'fjd-al02': '-',
      'fjd-ats': '0.5〜26km/h（オプションで0.1km/h）',
      'esteer-20-max': '0.1〜30km/h（標準対応）',
      'esteer-20': '0.1〜30km/h（標準対応）'
    },
    {
      feature: 'ターン機能',
      'fjd-at2-max': '○',
      'fjd-at2': '○',
      'fjd-al02': '自動操舵併用時○',
      'fjd-ats': '○',
      'esteer-20-max': '○',
      'esteer-20': '○'
    },
    {
      feature: 'ISOBUS対応',
      'fjd-at2-max': '対応',
      'fjd-at2': '対応',
      'fjd-al02': '対応',
      'fjd-ats': '対応',
      'esteer-20-max': 'VT/TC-SC/TC-GEO対応',
      'esteer-20': 'VT/TC-SC/TC-GEO対応'
    },
    {
      feature: '価格帯',
      'fjd-at2-max': '中価格',
      'fjd-at2': '低価格',
      'fjd-al02': '中価格',
      'fjd-ats': '中価格',
      'esteer-20-max': '中価格',
      'esteer-20': '低価格'
    }
  ];

  const products = [
    { id: 'fjd-at2-max', name: 'FJD AT2 Max', color: 'bg-blue-500' },
    { id: 'fjd-at2', name: 'FJD AT2', color: 'bg-blue-400' },
    { id: 'fjd-al02', name: 'FJD AL02', color: 'bg-green-500' },
    { id: 'fjd-ats', name: 'FJD ATS', color: 'bg-purple-500' },
    { id: 'esteer-20-max', name: 'eSteer 20 MAX', color: 'bg-orange-500' },
    { id: 'esteer-20', name: 'eSteer 20', color: 'bg-orange-400' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">製品比較表</h2>
          <p className="text-xl sm:text-lg text-gray-600">各製品の特徴を一覧で比較できます</p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-2xl shadow-lg overflow-hidden">
            <thead>
              <tr className="bg-[#2A6041] text-white">
                <th className="px-4 py-4 text-left font-semibold">項目</th>
                {products.map((product) => (
                  <th key={product.id} className="px-4 py-4 text-center font-semibold min-w-[120px]">
                    <div className={`w-4 h-4 rounded-full ${product.color} mx-auto mb-2`}></div>
                    {product.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr key={row.feature} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                  <td className="px-4 py-4 font-semibold text-[#2A6041] border-r border-gray-200">{row.feature}</td>
                  {products.map((product) => (
                    <td key={product.id} className="px-4 py-4 text-center text-gray-700 text-sm">
                      {row[product.id] || '-'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* どちらを選ぶべき？ */}
        <div className="bg-white rounded-xl p-8 shadow-lg max-w-4xl mx-auto text-center mt-16">
          <h3 className="text-xl font-bold text-gray-900 mb-4">どちらを選ぶべき？</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="text-center">
              <h4 className="font-semibold text-[#2A6041] mb-3">FJDynamicsがおすすめの方</h4>
              <ul className="space-y-2 text-sm text-gray-600 text-center list-none">
                <li>• 複数の農機で使い回したい</li>
                <li>• 将来的に機能拡張を考えている</li>
                <li>• 細かな設定にこだわりたい</li>
                <li>• スマートフォンの操作に慣れている</li>
              </ul>
            </div>
            <div className="text-center">
              <h4 className="font-semibold text-[#2A6041] mb-3">EFIXがおすすめの方</h4>
              <ul className="space-y-2 text-sm text-gray-600 text-center list-none">
                <li>• 初めて自動操舵を導入する</li>
                <li>• シンプルな操作を重視する</li>
                <li>• デジタル機器が苦手</li>
                <li>• すぐに使い始めたい</li>
              </ul>
            </div>
          </div>
          <div className="mt-6 p-4 bg-gray-50 rounded-lg text-center">
            <p className="text-xs text-gray-600">※1：RTK精度 ±2.5cm は、RTKまたはSkyTrix等の補正サービス利用時の達成可能精度です。SkyTrixは基地局やネットワーク信号が不要な独自の測位モードで、収束時間は5分未満です。</p>
          </div>
        </div>
      </div>
    </section>
  );
}